import React, { useEffect, useState } from "react";
import api from "../api";

const defaultForm = {
  eventId: "",
  kode: "",
  judul: "",
  hari: "SABTU",
  urutan: "1",
  isActive: true,
};

const AdminWorkshop = () => {
  const apiUrl = process.env.REACT_APP_API_ENDPOINT;
  const [list, setList] = useState([]);
  const [events, setEvents] = useState([]);
  const [pricing, setPricing] = useState({ priceOne: 0, priceTwo: 0 });
  const [showModal, setShowModal] = useState(false);
  const [editId, setEditId] = useState(null);
  const [form, setForm] = useState(defaultForm);
  const [page, setPage] = useState(0);
  const [size, setSize] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const [search, setSearch] = useState("");
  const [filterEventId, setFilterEventId] = useState("");

  const loadList = () => {
    const params = new URLSearchParams({ page, size });
    if (filterEventId) params.set("eventId", filterEventId);
    const base = search.trim()
      ? `${apiUrl}/api/workshop/search?q=${encodeURIComponent(search.trim())}&${params}`
      : `${apiUrl}/api/workshop?${params}`;
    api.get(base).then((res) => {
      setList(res.data.content);
      setTotalPages(res.data.totalPages);
    });
  };

  useEffect(() => {
    api.get(`${apiUrl}/api/events?page=0&size=100`).then((res) => setEvents(res.data.content || []));
    api.get(`${apiUrl}/api/workshop/pricing`).then((res) => setPricing(res.data));
  }, [apiUrl]);

  useEffect(() => {
    loadList();
  }, [apiUrl, page, size, showModal, search, filterEventId]);

  const openCreate = () => {
    setEditId(null);
    setForm({
      ...defaultForm,
      eventId: filterEventId || (events[0]?.id ? String(events[0].id) : ""),
    });
    setShowModal(true);
  };

  const openEdit = (item) => {
    setEditId(item.id);
    setForm({
      eventId: String(item.event?.id || ""),
      kode: item.kode || "",
      judul: item.judul || "",
      hari: item.hari || "SABTU",
      urutan: String(item.urutan ?? 1),
      isActive: item.isActive !== false,
    });
    setShowModal(true);
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const data = new FormData();
    data.append("eventId", form.eventId);
    data.append("kode", form.kode);
    data.append("judul", form.judul);
    data.append("hari", form.hari);
    data.append("urutan", form.urutan);
    data.append("isActive", form.isActive);
    try {
      if (editId) {
        await api.put(`${apiUrl}/api/workshop/${editId}`, data);
      } else {
        await api.post(`${apiUrl}/api/workshop`, data);
      }
      setShowModal(false);
    } catch {
      alert("Gagal simpan workshop");
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Yakin hapus workshop ini?")) return;
    try {
      await api.delete(`${apiUrl}/api/workshop/${id}`);
      loadList();
    } catch {
      alert("Gagal hapus. Workshop mungkin sudah dipakai peserta — nonaktifkan saja.");
    }
  };

  const formatIdr = (n) =>
    Number(n || 0).toLocaleString("id-ID", { style: "currency", currency: "IDR" });

  const setPageListItems = (event) => {
    const value = parseInt(event.target.getAttribute("data-value"), 10);
    setSize(value);
    setPage(0);
  };

  return (
    <div className="page-wrapper">
      <div className="page-header d-print-none">
        <div className="container-xl">
          <div className="row g-2 align-items-center">
            <div className="col">
              <h2 className="page-title">Pengelolaan Workshop</h2>
              <p className="text-muted mb-0">
                Paket biaya: 1 workshop {formatIdr(pricing.priceOne)} · 2 workshop {formatIdr(pricing.priceTwo)}
              </p>
            </div>
            <div className="col-md-auto">
              <select
                className="form-select"
                value={filterEventId}
                onChange={(e) => {
                  setFilterEventId(e.target.value);
                  setPage(0);
                }}
              >
                <option value="">Semua event</option>
                {events.map((ev) => (
                  <option key={ev.id} value={ev.id}>
                    {ev.eventCode} — {ev.title}
                  </option>
                ))}
              </select>
            </div>
            <div className="col-md-auto">
              <input
                type="text"
                className="form-control"
                placeholder="Cari judul workshop"
                value={search}
                onChange={(e) => {
                  setSearch(e.target.value);
                  setPage(0);
                }}
              />
            </div>
            <div className="col-auto">
              <button type="button" className="btn btn-primary" onClick={openCreate}>
                Tambah Workshop
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="page-body">
        <div className="container-xl">
          <div className="card">
            <div className="table-responsive">
              <table className="table card-table table-vcenter text-nowrap table-hover">
                <thead>
                  <tr>
                    <th>No</th>
                    <th>Event</th>
                    <th>Kode</th>
                    <th>Judul</th>
                    <th>Hari</th>
                    <th>Urutan</th>
                    <th>Aktif</th>
                    <th>Aksi</th>
                  </tr>
                </thead>
                <tbody>
                  {list.length === 0 ? (
                    <tr>
                      <td colSpan={8} className="text-center">
                        Belum ada data workshop
                      </td>
                    </tr>
                  ) : (
                    list.map((item, idx) => (
                      <tr key={item.id}>
                        <td>{page * size + idx + 1}</td>
                        <td>{item.event?.eventCode || "—"}</td>
                        <td>{item.kode}</td>
                        <td style={{ maxWidth: 320, whiteSpace: "normal" }}>{item.judul}</td>
                        <td>{item.hari}</td>
                        <td>{item.urutan}</td>
                        <td>
                          <span className={`badge bg-${item.isActive ? "green" : "secondary"}`}>
                            {item.isActive ? "Ya" : "Tidak"}
                          </span>
                        </td>
                        <td>
                          <button
                            type="button"
                            className="btn btn-sm btn-warning me-1"
                            onClick={() => openEdit(item)}
                          >
                            Edit
                          </button>
                          <button
                            type="button"
                            className="btn btn-sm btn-danger"
                            onClick={() => handleDelete(item.id)}
                          >
                            Hapus
                          </button>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
            <div className="card-footer d-flex align-items-center">
              <div className="dropdown">
                <a className="btn dropdown-toggle" data-bs-toggle="dropdown" href="/" onClick={(e) => e.preventDefault()}>
                  <span className="me-1">{size}</span> records
                </a>
                <div className="dropdown-menu">
                  {[10, 20, 50].map((val) => (
                    <button
                      key={val}
                      type="button"
                      className="dropdown-item"
                      onClick={setPageListItems}
                      data-value={val}
                    >
                      {val} records
                    </button>
                  ))}
                </div>
              </div>
              <ul className="pagination m-0 ms-auto">
                <li className={`page-item${page === 0 ? " disabled" : ""}`}>
                  <button
                    type="button"
                    className="page-link"
                    disabled={page === 0}
                    onClick={() => setPage(page - 1)}
                  >
                    prev
                  </button>
                </li>
                {[...Array(totalPages)].map((_, idx) => (
                  <li key={idx} className={`page-item${page === idx ? " active" : ""}`}>
                    <button type="button" className="page-link" onClick={() => setPage(idx)}>
                      {idx + 1}
                    </button>
                  </li>
                ))}
                <li className={`page-item${page >= totalPages - 1 ? " disabled" : ""}`}>
                  <button
                    type="button"
                    className="page-link"
                    disabled={page >= totalPages - 1}
                    onClick={() => setPage(page + 1)}
                  >
                    next
                  </button>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      {showModal && (
        <div className="modal show d-block" tabIndex={-1} style={{ background: "rgba(0,0,0,0.3)" }}>
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <form onSubmit={handleSubmit}>
                <div className="modal-header">
                  <h5 className="modal-title">{editId ? "Edit Workshop" : "Tambah Workshop"}</h5>
                  <button type="button" className="btn-close" onClick={() => setShowModal(false)} />
                </div>
                <div className="modal-body">
                  <div className="mb-3">
                    <label className="form-label">Event</label>
                    <select
                      className="form-select"
                      name="eventId"
                      value={form.eventId}
                      onChange={handleChange}
                      required
                    >
                      <option value="">Pilih event</option>
                      {events.map((ev) => (
                        <option key={ev.id} value={ev.id}>
                          {ev.eventCode} — {ev.title}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="row">
                    <div className="col-md-4 mb-3">
                      <label className="form-label">Kode</label>
                      <input
                        type="text"
                        className="form-control"
                        name="kode"
                        value={form.kode}
                        onChange={handleChange}
                        placeholder="W1"
                        required
                      />
                    </div>
                    <div className="col-md-4 mb-3">
                      <label className="form-label">Hari</label>
                      <select className="form-select" name="hari" value={form.hari} onChange={handleChange} required>
                        <option value="SABTU">Sabtu</option>
                        <option value="MINGGU">Minggu</option>
                      </select>
                    </div>
                    <div className="col-md-4 mb-3">
                      <label className="form-label">Urutan</label>
                      <input
                        type="number"
                        min="1"
                        className="form-control"
                        name="urutan"
                        value={form.urutan}
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Judul workshop</label>
                    <textarea
                      className="form-control"
                      name="judul"
                      rows={3}
                      value={form.judul}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <div className="form-check">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      name="isActive"
                      id="workshopActive"
                      checked={form.isActive}
                      onChange={handleChange}
                    />
                    <label className="form-check-label" htmlFor="workshopActive">
                      Aktif (tampil di form pendaftaran peserta)
                    </label>
                  </div>
                </div>
                <div className="modal-footer">
                  <button type="button" className="btn btn-secondary" onClick={() => setShowModal(false)}>
                    Batal
                  </button>
                  <button type="submit" className="btn btn-primary">
                    {editId ? "Simpan" : "Tambah"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AdminWorkshop;
